import React from 'react';
import {Modal, ModalTitle} from 'react-bootstrap';
import {useStrings} from '@zvne/fe-framework/dist/presentation/language/strings';
import {strings} from './strings';
import {keycloak} from '../../../data-access/reusable/keycloak';
import {useAuth} from '../../reusable/auth/auth-context';
import './auth-screen.css';

export function AuthScreen() {
    const auth = useAuth();
    const s = useStrings(strings);
    return (
        <Modal.Dialog className={'auth-modal'}>
            <Modal.Header>
                <ModalTitle>
                    {!auth.isAuthenticated && s.loginRequiredTitle}
                    {auth.isAuthenticated && s.unauthorizedTitle}
                </ModalTitle>
            </Modal.Header>
            <Modal.Body>
                {!auth.isAuthenticated && <p>{s.loginRequiredBody}</p>}
                {auth.isAuthenticated &&
                <>
                    <p>
                        {s.unauthorizedBody}
                        <br/>
                        {s.currentlyLoggedInAs}
                        &nbsp;
                        <b>{auth.username}</b>
                    </p>
                </>
                }
            </Modal.Body>
            <Modal.Footer>
                {!auth.isAuthenticated &&
                <button
                    type={'button'}
                    className={'btn btn-primary btn-block'}
                    onClick={() => keycloak.login()}
                >
                    {s.login}
                </button>
                }
                {auth.isAuthenticated &&
                <button
                    type={'button'}
                    className={'btn btn-primary btn-block'}
                    onClick={() => keycloak.logout()}
                >
                    {s.logout}
                </button>
                }
            </Modal.Footer>
        </Modal.Dialog>
    );
}
